module.exports = __webpack_public_path__ + "static/media/MHRM09N1010.280bf4c4.svg";